// import React from 'react';
// import Slider from 'react-slick';
// import { HiArrowLongRight } from "react-icons/hi2";
// import "./style.css"
// import getProjectDemo from './DemoData/DemoData';
// const OurProjects = () => {
//     return (
//         <div className='centerContainer container'>
//              <h1 className="tittleText">Our Projects</h1>
//              <div className='projectContainer'>
//                 {
//                     getProjectDemo()?.map((item,idx)=>{
//                         return(
//                             <div className='projectCard'>
//                                 <img alt='projectimage' src={item.img}/>
//                                 <div style={{backgroundColor:item.color}} className='flotContainer'>
//                                     <div style={{display:"flex",gap:"10px"}}>
//                                         {
//                                             item.key?.map((item,idx)=><span style={{backgroundColor:"white",padding:"4px",borderRadius:"2px",fontSize:"14px",fontWeight:"500"}}>{item}</span>)
//                                         }
//                                     </div>
//                                     <h1>{item.name}</h1>

//                                 </div>
//                             </div>
//                         )
//                     })
//                 }
//              </div>
//         </div>
//     );
// };

// export default OurProjects;

import React, { useState, useRef } from "react";
import getProjectDemo from "./DemoData/DemoData";
import "./style.css";

const OurProjects = () => {
  const projects = getProjectDemo();
  const [currentIndexes, setCurrentIndexes] = useState({});

  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const handleSwipe = (idx, direction, maxLength) => {
    setCurrentIndexes((prev) => {
      const current = prev[idx] || 0;
      const next =
        direction === "left"
          ? (current + 1) % maxLength
          : (current - 1 + maxLength) % maxLength;
      return { ...prev, [idx]: next };
    });
  };

  return (
    <div className="centerContainer container">
      {/* <h1 className="tittleText">Our Projects</h1>
      <div className="projectContainer">
        {projects.map((item, idx) => {
          const currentImgIndex = currentIndexes[idx] || 0;
          const hasMultiple = item.img.length > 1;

          return (
            <div
              className="projectCard"
              key={idx}
              onTouchStart={(e) => (touchStartX.current = e.changedTouches[0].clientX)}
              onTouchEnd={(e) => {
                touchEndX.current = e.changedTouches[0].clientX;
                const delta = touchEndX.current - touchStartX.current;
                if (Math.abs(delta) > 50) {
                  handleSwipe(idx, delta < 0 ? "left" : "right", item.img.length);
                }
              }}
            >
              <img
                className="carouselImg"
                alt="project"
                src={item.img[currentImgIndex]}
              />

              {hasMultiple && (
                <div className="indicatorContainer">
                  {item.img.map((_, dotIdx) => (
                    <span
                      key={dotIdx}
                      className={`dot ${currentImgIndex === dotIdx ? "active" : ""}`}
                      onClick={() =>
                        setCurrentIndexes((prev) => ({ ...prev, [idx]: dotIdx }))
                      }
                    />
                  ))}
                </div>
              )}

              <div style={{ backgroundColor: item.color }} className="flotContainer">
                <h1>{item.name}</h1>
                <div className="tagContainer">
                  {item.key.map((tag, tagIdx) => (
                    <span className="projectTag" key={tagIdx}>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div> */}
    </div>
  );
};

export default OurProjects;
